var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5565 0.591797H13.5806V3.37221H17.5565V7.54282H20.2071V3.37221C20.2071 1.84298 19.0143 0.591797 17.5565 0.591797Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.327148 3.37221V7.54282H2.97775V3.37221H6.95366V0.591797H2.97775C1.51992 0.591797 0.327148 1.84298 0.327148 3.37221Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97775 14.4941H0.327148V18.6648C0.327148 20.194 1.51992 21.4452 2.97775 21.4452H6.95366V18.6648H2.97775V14.4941Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5565 18.6648H13.5806V21.4452H17.5565C19.0143 21.4452 20.2071 20.194 20.2071 18.6648V14.4941H17.5565V18.6648Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5905 9.62695H8.93994V12.4074H11.5905V9.62695Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2404 6.84766H11.5898V9.62807H14.2404V6.84766Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94162 6.84766H6.29102V9.62807H8.94162V6.84766Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2404 12.4082H11.5898V15.1886H14.2404V12.4082Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94162 12.4082H6.29102V15.1886H8.94162V12.4082Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuZones);
export default __webpack_public_path__ + "static/media/menu_zones.3d59d42b6be973c7d1af470e2e21f911.svg";
export { ForwardRef as ReactComponent };